import styled from "@emotion/styled";
import { useMantineColorScheme } from "@mantine/core";

export const RightSpace = () => {
  const { colorScheme } = useMantineColorScheme();
  return <RightSpaceContainer theme={{ colorScheme }} />;
};

const RightSpaceContainer = styled.span<{ theme: { colorScheme: "dark" | "light" } }>`
  flex: 1 0 0;
  align-self: stretch;
  background: ${({ theme }) =>
    theme.colorScheme === "dark" ? "var(--gray-9, #212529)" : "var(--gray-2, #f8f9fa)"};
  border-bottom: ${({ theme }) =>
      theme.colorScheme === "dark" ? "var(--gray-9, #212529)" : "var(--gray-2, #f8f9fa)"}
    solid 1px;
  opacity: 0.2;
`;
